// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.jsondiffpatch-left-value pre,
div.jsondiffpatch-right-value pre,
li.jsondiffpatch-added pre,
li.jsondiffpatch-added .jsondiffpatch-property-name,
li.jsondiffpatch-deleted pre,
li.jsondiffpatch-deleted .jsondiffpatch-property-name {
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/components/user-activity-events/diff-presenter/styles.less"],"names":[],"mappings":"AAAA;;;;;;EAME,YAAA;AACF","sourcesContent":["div.jsondiffpatch-left-value pre,\ndiv.jsondiffpatch-right-value pre,\nli.jsondiffpatch-added pre,\nli.jsondiffpatch-added .jsondiffpatch-property-name,\nli.jsondiffpatch-deleted pre,\nli.jsondiffpatch-deleted .jsondiffpatch-property-name {\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
